const translations = {
  "en": {
    "Cancel": "Cancel"
  },
  "zh-tw": {
    "Cancel": "取消"
  }
};

export default translations;
